var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderUnit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0882 5.27332L11.2362 5.5H11.5069H20C20.8284 5.5 21.5 6.17157 21.5 7V18C21.5 18.8284 20.8284 19.5 20 19.5H4C3.17157 19.5 2.5 18.8284 2.5 18V5C2.5 4.17157 3.17157 3.5 4 3.5H9.93058L11.0882 5.27332Z",
    fill: "#CDD0D4",
    stroke: "#74797D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4036 8.11328V14.052C15.4036 14.996 15.1004 15.7447 14.4941 16.2981C13.8919 16.8474 13.0883 17.1221 12.0833 17.1221C11.066 17.1221 10.2583 16.8515 9.66016 16.3103C9.06201 15.7651 8.76294 15.0103 8.76294 14.0459V8.11328H10.301V14.0581C10.301 14.6522 10.4516 15.1059 10.7527 15.4192C11.0538 15.7325 11.4973 15.8892 12.0833 15.8892C13.2714 15.8892 13.8655 15.2625 13.8655 14.0093V8.11328H15.4036Z",
    fill: "#74797D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderUnit);
export default __webpack_public_path__ + "static/media/folder-unit.3f72f492673e0c1f6ef3817aadb57539.svg";
export { ForwardRef as ReactComponent };